import { Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onCancel: () => void;
    onDelete: () => void;
};

const DeleteDeclarationModal = ({ open, onCancel, onDelete }: Props) => {
    return (
        <ConfirmationModal
            width={632}
            type="error"
            title="Delete Draft Declaration?"
            confirmButtonText="Delete"
            icon={<DeleteOutlined />}
            content={
                <Typography.Text>
                    The draft declaration will be deleted and all information associated with it will be lost
                </Typography.Text>
            }
            open={open}
            onCancel={onCancel}
            onConfirm={onDelete}
        />
    );
};

export default DeleteDeclarationModal;
